import {
    deleteReport,
    generateReportColumns,
    getReportColumns,
    getReports
} from './services/service';
import {reportGeneratorsStore} from './stores/ReportGeneratorsStore';

const KEY = 'analyticsAutomations';

const deleteReportAuto = async (reportId: number) => {
    await deleteReport(reportId);
};

const updateFieldsAuto = async (selectedFields: string[]) => {
    const {currentScreen} = reportGeneratorsStore;
    const {updateColumns, setSelectedNodes, duplicateId, reportId, nodeId, setLinkId, linkId} =
        currentScreen.currentReport;

    const [nodes, columnsRS] = await Promise.all([
        getReportColumns(nodeId, duplicateId || reportId),
        generateReportColumns(selectedFields, duplicateId || reportId, linkId)
    ]);

    const columns = columnsRS?.columns || [];
    const link = columnsRS?.linkId;

    const fields = nodes?.all.filter(node => selectedFields.includes(node.NodeId));
    const fieldsMap = new Map(fields.map(col => [col.NodeId, col]));

    updateColumns(columns);
    setLinkId(link);
    setSelectedNodes(fieldsMap);
};

const getCurrReportNodesId = () => {
    const {currentScreen} = reportGeneratorsStore;
    return currentScreen?.currentReport?.nodeId;
};

export const analyticsInitAutomationExport = () => {
    if (!window[KEY]) {
        window[KEY] = {};
        window[KEY]['deleteReport'] = deleteReportAuto;
        window[KEY]['updateFields'] = updateFieldsAuto;
        window[KEY]['getReports'] = getReports;
        window[KEY]['getNodesId'] = getCurrReportNodesId;
    }
};
